export enum CouponStatus {
    AVAILABLE = "AVAILABLE",
    NOT_AVAILABLE = "NOT_AVAILABLE",
    CLAIMED = "CLAIMED",
}
